/**
 * File-name tokens for attendance-report XLSX downloads. Names are built
 * client-side (rather than read from Content-Disposition) so per-subject
 * exports carry the person/event name the user is looking at.
 */
export const REPORT_EXPORT_FILE = Object.freeze({
  GENERAL: 'educational-events-attendance',
  PERSON_SUFFIX: 'events',
  EVENT_SUFFIX: 'attendees',
});

// Strip chars that would break the anchor `download` attribute.
const INVALID_FILENAME_CHARS = /[\\/:*?"<>|]/g;

/**
 * @param {string} [name]
 * @returns {string}
 */
export function sanitize(name) {
  return (name || '').replace(INVALID_FILENAME_CHARS, ' ').replace(/\s+/g, ' ').trim();
}

/**
 * @param {string} subject person or event name
 * @param {string} suffix REPORT_EXPORT_FILE.PERSON_SUFFIX | EVENT_SUFFIX
 * @returns {string}
 */
export function buildReportFileName(subject, suffix) {
  const clean = sanitize(subject);
  const base = clean ? `${clean} - ${suffix}` : REPORT_EXPORT_FILE.GENERAL;
  return `${base}.xlsx`;
}
